import { useQuery } from "@tanstack/react-query";

import { Zotero } from "../../../api/zotero";
import { QueryKey } from "../../../consts/query-keys";
import { ApiError } from "../../../types/api-error";

type UseZoteroStatusConfig = {
  enabled?: boolean;
};

export function useZoteroStatus({
  enabled = true,
}: UseZoteroStatusConfig = {}) {
  const { isPending, refetch, error } = useQuery<unknown, ApiError>({
    queryKey: [QueryKey.ZoteroStatus],
    queryFn: () => Zotero.getStatus(),
    // Poll every 3 seconds only when enabled
    refetchInterval: enabled ? 3000 : false,
    // Don't throw errors, handle them as valid states
    throwOnError: false,
    // Don't retry on 429 as that's our expected state
    retry: false,
  });

  // If we get a 429 response, sync is running
  const isSyncRunning = error?.Status === 429;

  return {
    isSyncRunning,
    isPending,
    refetch,
  };
}
